import React from 'react';
import { Helmet } from 'react-helmet-async';
import { AlertTriangle, Shield, Info, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Disclaimer() {
  return (
    <>
      <Helmet>
        <title>Legal Disclaimer | Parakh Services</title>
        <meta 
          name="description" 
          content="Important legal information about our third-party repair services and brand relationships." 
        />
      </Helmet>

      <div className="bg-white py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-8">
            <AlertTriangle className="h-12 w-12 text-red-500 mx-auto mb-4" />
            <h1 className="text-3xl font-bold text-gray-900">Legal Disclaimer</h1>
          </div>

          {/* Main Content */}
          <div className="prose prose-lg max-w-none">
            {/* Third Party Service Provider */}
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-8">
              <div className="flex items-start">
                <AlertTriangle className="h-5 w-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
                <p className="text-red-700">
                  Parakh Services is an independent third-party repair service provider. We are not affiliated with, authorized by, or in any way officially connected with any of the brands or manufacturers mentioned on this website.
                </p>
              </div>
            </div>

            {/* Service Scope */}
            <div className="mb-8">
              <h2 className="flex items-center text-xl font-semibold mb-4">
                <Shield className="h-6 w-6 text-blue-600 mr-2" />
                Service Scope
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>We provide repair services for out-of-warranty products only.</li>
                <li>Our services do not affect or extend the manufacturer's warranty.</li>
                <li>All brand names, trademarks, and logos remain the property of their respective owners.</li>
                <li>We use compatible spare parts that may not be original manufacturer parts.</li>
              </ul>
            </div>

            {/* Important Notes */}
            <div className="mb-8">
              <h2 className="flex items-center text-xl font-semibold mb-4">
                <Info className="h-6 w-6 text-blue-600 mr-2" />
                Important Notes
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>For in-warranty products, please contact the manufacturer's authorized service center.</li>
                <li>Our warranty covers only the specific repair work performed by us.</li>
                <li>Service availability may vary by location and product type.</li>
                <li>Final service charges will be determined after diagnosis of the issue.</li>
              </ul>
            </div>

            {/* Contact Section */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h2 className="flex items-center text-xl font-semibold mb-4">
                <Phone className="h-6 w-6 text-blue-600 mr-2" />
                Questions or Concerns?
              </h2>
              <p className="text-gray-600 mb-4">
                If you have any questions about our services or this disclaimer, please contact us:
              </p>
              <div className="space-y-2">
                <a href="tel:+918302311436" className="text-blue-600 hover:text-blue-700 block">
                  Phone: +91 8302311436
                </a>
                <a href="mailto:contact@parakhservices.com" className="text-blue-600 hover:text-blue-700 block">
                  Email: contact@parakhservices.com
                </a>
              </div>
            </div>

            {/* Back to Home */}
            <div className="mt-8 text-center">
              <Link
                to="/"
                className="inline-flex items-center text-blue-600 hover:text-blue-700"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}